import React from "react";
import "./index.css";

import {createSearchParams} from "react-router-dom";
import Sidebar from "../../../../components/Sidebar";
import TableHeader from "../../../../components/TableHeader/index";
import PageHeader from "../../../../components/PageHeader";
import Pagination from "../../../../components/Pagination";
import ModalDeleteUser from "./modalDeleteUser";
import ModalCreateUser from "./modalCreateUser";
import ModalEditUser from "./modalEditUser";
import {checkPermission} from "../../../../utils/common";
import LinkPlus from "../../../../components/Link/LinkPlus";
import PublicSecureAuthorization
    from "../../../../services/system/secure-authorization/secure-authorization-controller";
import UserController from "../../../../services/system/user/user-controller";
import {getSchoolId} from "../../../../utils/authority";

class UserManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isSchoolId: getSchoolId() >= 0,
            fullName: "",
            gender: "",
            role: "",
            status: "",
            username: "",

            listData: [],
            pageNumber: 0,
            pageSize: 10,
            page: 0,
            sort: 'id',
            descending: 'created_at desc',
            totalItem: 0,
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "username",
                    name: "Tên đăng nhập",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Tên hiển thị",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "phone",
                    name: "Điện thoại",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "status",
                    name: "Trạng thái",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "",
                    name: "Thao tác",
                    style: {minWidth: 120, textAlign: "center"},
                    sort: false
                }
            ]
        };
    }

    componentDidMount() {
        // this.onhandleSearch();
        this.setState({showLoading: true},
            () => this.getListUser()
        )
        this.getListGroupUser()
    }
    getListGroupUser() {
        PublicSecureAuthorization.getListRoles(res => {
            if (res.success) {
                let data = res.data.content;
                this.setState(
                    {
                        listGroupUser: res.data.content
                    }
                );
            } else {
            }
        });
    }
    // ---------------------------------------------------------------------------------------------------------

    getListUser() {
        let {pageNumber, pageSize, descending} = this.state;

        let payload = {
            pageNumber: pageNumber,
            pageSize: pageSize,
            sort: descending
        };
        UserController.getListUser(payload, res => {
            if (res.success) {
                let data = res.data.content;
                this.setState(
                    {
                        listData: res.data.content,
                        totalItem: res.data.totalElements,
                        totalPage: Math.round(res.data.totalElements / this.state.pageSize),
                        showLoading: data.length < 0
                    }
                );
            } else {
            }
        });
    }

    onhandleSearch = () => {
        let payload = {
            "fullName": this.state.fullName,
            "gender": this.state.gender,
            "group": this.state.role,
            "pageNumber": this.state.pageNumber,
            "pageSize": this.state.pageSize,
            "sort": this.state.descending,
            "status": this.state.status,
            "username": this.state.username
        }
        UserController.searchUser(payload, res => {
            if (res.success) {
                let data = res.data.content;
                this.setState(
                    {
                        listData: res.data.content,
                        totalItem: res.data.totalElements,
                        totalPage: Math.round(res.data.totalElements / this.state.pageSize),
                        showLoading: data.length < 0
                    }
                );
            } else {
            }
        });
    };

    onHandleClearText() {
        this.setState(
            {
                sort: "id",
                descending: 'created_at desc',
            },
            () => this.onhandleSearch()
        );
    }

    handleChangePage = page => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.getListUser();
            }
        );
    };

    render() {
        let {listData, pageNumber, header} = this.state;
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="user-management" parentClass="system-school-management"/>
                        <div className="col-md-10 tab-content with-loading">
                            {this.state.showLoading &&
                            <div className="content-loading col-12 ml-3 align-items-center"
                                 style={{display: 'block'}}>
                                <div className="spinner-grow text-info"/>
                            </div>
                            }
                            <div className="card col-12">
                                <div className="pt-3 mb-2">
                                    <PageHeader routerEnable={true} title="Quản lý người dùng"/>
                                    <form className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-0 pr-md-3 d-flex mb-1">
                                                <label className="label-item col-md-4 col-5">Tên đăng nhập</label>
                                                <input
                                                    placeholder="Nhập tên đăng nhập cần tìm"
                                                    name="Tên đăng nhập"
                                                    type="text"
                                                    className="form-control shadow-none font-14"
                                                    style={{width: "100%", height: 35, padding: 8}}
                                                    value={this.state.username}
                                                    maxLength={50}
                                                    onKeyPress={(e) => {
                                                        if (e.key === 'Enter') {
                                                            this.onhandleSearch()
                                                        }
                                                    }}
                                                    onChange={val =>
                                                        this.setState({username: val.target.value.trim()})
                                                    }
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-0 pr-md-3 d-flex mb-1">
                                                <label className="label-item col-md-4 col-5">Họ và tên</label>
                                                <input
                                                    placeholder="Nhập họ và tên"
                                                    name="Họ và tên"
                                                    type="text"
                                                    className="form-control shadow-none font-14"
                                                    style={{width: "100%", height: 35, padding: 8}}
                                                    value={this.state.fullName}
                                                    maxLength={50}
                                                    onKeyPress={(e) => {
                                                        if (e.key === 'Enter') {
                                                            this.onhandleSearch()
                                                        }
                                                    }}
                                                    onChange={val =>
                                                        this.setState({fullName: val.target.value.trim()})
                                                    }
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-0 pr-md-3 d-flex mb-1">
                                                <label className="label-item col-md-4 col-5">Giới tính</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.gender}
                                                    onChange={(e) => {
                                                        this.state.gender = e.target.value;
                                                        this.setState({
                                                            gender: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="">Tất cả</option>
                                                    <option value="Male">Nam</option>
                                                    <option value="FEMALE">Nữ</option>
                                                    <option value="OTHER">Khác</option>
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-0 pr-md-3 d-flex mb-1">
                                                <label className="label-item col-md-4 col-5">Nhóm người dùng</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.role}
                                                    onChange={(e) => {
                                                        this.state.role = e.target.value;
                                                        this.setState({
                                                            role: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="">Tất cả</option>
                                                    {this.state.listGroupUser?.map((item, index) => <option value={item.role}>{item.role}</option>)}

                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-0 pr-md-3 d-flex mb-1">
                                                <label className="label-item col-md-4 col-5">Trạng thái tài khoản</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.status}
                                                    onChange={(e) => {
                                                        this.state.status = e.target.value;
                                                        this.setState({
                                                            status: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="">Tất cả</option>
                                                    <option value="ACTIVE">Hoạt động</option>
                                                    <option value="INACTIVE">Khóa</option>
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-0 pr-md-3 d-flex mb-1" style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}>
                                                <button
                                                    style={{height: 35}}
                                                    type="button"
                                                    className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                    onClick={() => this.onhandleSearch()}
                                                >
                                                    Tìm kiếm
                                                </button>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-0 pr-md-3 d-flex"
                                                 style={{
                                                     alignItems: "center",
                                                     justifyContent: "right"
                                                 }}>
                                                {this.state.isSchoolId && checkPermission("USER_ADD") &&
                                                    <button
                                                        style={{height: 35, marginRight: 12}}
                                                        type="button"
                                                        className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                        onClick={() => this.setState({showModalCreate: true})}
                                                    >
                                                        Thêm mới
                                                    </button>
                                                }
                                                {/*<button*/}
                                                {/*    style={{height: 35, marginRight: 12}}*/}
                                                {/*    type="button"*/}
                                                {/*    className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"*/}
                                                {/*    onClick={() => this.setState({showModalCreate: true})}*/}
                                                {/*>*/}
                                                {/*    Xuất Excell*/}
                                                {/*</button>*/}
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="p-0 mb-3">
                                    <div className="table-wrapper">
                                        <table
                                            className="table table-striped table-data table-responsive table-bordered">
                                            <table className="table">
                                                <thead>
                                                <TableHeader
                                                    header={header}
                                                />
                                                </thead>
                                                {!this.state.listData ||
                                                this.state.listData.length == 0 ? (
                                                    <tbody>
                                                    <tr>
                                                        <td colSpan={12}>
                                                            <div className="text-center">
                                                                Không có dữ liệu
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                    {listData &&
                                                    listData.length > 0 &&
                                                    listData?.map((row, index) => (
                                                        <tr style={{height: 50}}>
                                                            <td style={{textAlign: "center"}} scope="row">
                                                                {" "}
                                                                {this.state.pageNumber * this.state.pageSize +
                                                                index +
                                                                1}
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                                {row.username}
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                                {row.fullName}
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                                {row.phone1}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {row.status=="INACTIVE" ? <span className="badge badge-danger" style={{color: "white"}}>Khóa</span> : <span className="badge badge-success" style={{color: "white"}}>Hoạt động</span>}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {/*<LinkPlus*/}
                                                                {/*    style={{color: '#000'}}*/}
                                                                {/*    to={{*/}
                                                                {/*        pathname: "/ad-sas-school/chi-tiet-nguoi-dung",*/}
                                                                {/*        search: createSearchParams({*/}
                                                                {/*            id: `${parseFloat(row.uuid)}`*/}
                                                                {/*        }).toString(),*/}
                                                                {/*        state: {*/}
                                                                {/*            fromDashboard: true,*/}
                                                                {/*            id: parseFloat(row.uuid)*/}
                                                                {/*        }*/}
                                                                {/*    }}*/}
                                                                {/*>*/}
                                                                {/*    <button className="btn btn-action p-2"*/}
                                                                {/*            title='Xem chi tiết'*/}
                                                                {/*            style={{cursor: 'pointer'}}*/}
                                                                {/*    >*/}
                                                                {/*        <i className="ti-book"/>*/}
                                                                {/*    </button>*/}
                                                                {/*</LinkPlus>*/}
                                                                {checkPermission("USER_EDIT") &&
                                                                    <button className="btn btn-action p-2"
                                                                            title='Sửa'
                                                                            style={{cursor: 'pointer'}}
                                                                            onClick={() => {
                                                                                this.setState({itemSelected: row.uuid, showModalEdit: true})
                                                                            }}
                                                                    >
                                                                        <i className="ti-pencil-alt"/>
                                                                    </button>
                                                                }
                                                                {checkPermission("USER_DELETE") &&
                                                                    <button className="btn btn-action p-2"
                                                                            title='Xóa'
                                                                            style={{cursor: 'pointer'}}
                                                                            onClick={() => {
                                                                                this.setState({itemSelected: row.uuid, showModalDelete: true})
                                                                            }}
                                                                    >
                                                                        <i className="ti-trash"/>
                                                                    </button>
                                                                }
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                )}
                                            </table>
                                        </table>
                                    </div>
                                    <div className="pagination-right">
                                        <Pagination
                                            activePage={this.state.pageNumber}
                                            itemsCountPerPage={this.state.pageSize}
                                            totalItemsCount={this.state.totalItem}
                                            changeHandler={page => this.handleChangePage(page)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <ModalCreateUser
                    show={this.state.showModalCreate}
                    onHide={() => this.setState({showModalCreate: false})}
                    onRefresh={() => this.getListUser()}
                    id={this.state.itemSelected}
                    listGroupUser={this.state.listGroupUser}
                />
                <ModalEditUser
                    show={this.state.showModalEdit}
                    onHide={() => this.setState({showModalEdit: false})}
                    onRefresh={() => this.getListUser()}
                    id={this.state.itemSelected}
                    listGroupUser = {this.state.listGroupUser}
                />
                <ModalDeleteUser
                    show={this.state.showModalDelete}
                    onHide={() => this.setState({showModalDelete: false})}
                    onRefresh={() => this.getListUser()}
                    id={this.state.itemSelected}
                />
            </div>
        );
    }
}

export default UserManagement;
